import { BaseObject } from './BaseObject';

export class DashboardIndicador extends BaseObject {
    clase: string;
    json: string;
    subtitulo: string;
    tipo: string;
    titulo: string;
    icono: string;
    tituloEjeX: string;
    tituloEjeY: string;

    magnitud:number;
    unidadMedida:string;
    

    tipoSelected: any = null;
    claseSelected: any = null;
}